import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { reportList } from './request';
export default {
  data() {
    return {
      policyNo: '',
      data: [],
      columns: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    async getDataFun() {
      const h = this.$createElement;
      const res = await reportList({
        pageSize: this.pagination.pageSize,
        page: this.pagination.current,
        policyNo: this.policyNo
      });
      if (res.fieldConfig) {
        this.columns = res.fieldConfig.map(item => {
          let obj = item;
          obj.slots = {
            title: item.title
          };
          delete obj.title;
          if (item.ellipsis) {
            obj.customRender = text => h("a-tooltip", {
              "attrs": {
                "placement": "topLeft",
                "title": text
              }
            }, [text]);
          }
          return obj;
        });
        this.columns.push({
          slots: {
            title: '操作'
          },
          dataIndex: 'sort',
          key: '5',
          align: 'center',
          scopedSlots: {
            customRender: 'action'
          },
          width: 250
        });
      }
      this.data = res.items;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};